import React from "react";
import { Box, Divider, Stack } from "digiwash-components";
import {
  suggestResponsiveBoxRatioForServices,
  suggestResponsiveColumnForServices,
} from "../../helpers/general";

function SkeletonServices() {
  let loadingArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <Stack
      px="l"
      style={{ width: "100%" }}
      distribution="space-between"
      columns={suggestResponsiveColumnForServices(
        suggestResponsiveBoxRatioForServices().column
      )}
      fillIfEmpty
    >
      {loadingArray.map(() => {
        return (
          <>
            <Box>
              <Box
                bg="neutrals.250"
                br="m"
                style={{
                  width: "100%",
                }}
              >
                <Box p="m">
                  <Box
                    bg="common.white"
                    br="m"
                    style={{ width: "100%", height: 60 }}
                  />
                </Box>
                <Divider size="s" />
                <Box
                  bg="common.white"
                  style={{
                    width: 74,
                    height: 23,
                    borderTopRightRadius: 12,
                    borderBottomRightRadius: 12,
                  }}
                />
                <Divider size="xm" />
              </Box>
            </Box>
            <Divider size="xxxl" />
          </>
        );
      })}
    </Stack>
  );
}

export default SkeletonServices;
